module.exports = __webpack_public_path__ + "/login_ui/img/hk-803006af4ae9a6318fa094b86afe3004.svg";